<template>
  <div class="relative z-40">
    <div
      class="border-info-300 bg-info-50 flex flex-col gap-1 rounded-lg border p-4 text-gray-500"
    >
      <!-- Message -->
      <div class="flex items-center gap-2">
        <BaseIcon name="error-warning" filled class="text-lg" />
        <p class="font-bold">{{ title }}</p>
      </div>
      <p v-if="message" class="text-sm">{{ message }}</p>
      <!-- Action -->
      <BaseButton
        v-if="action"
        color="gray"
        outline
        small
        class="mt-1 w-fit"
        @click="action"
      >
        {{ actionLabel ?? "Meer informatie" }}
      </BaseButton>
    </div>
    <!-- Close -->
    <BaseButton
      color="gray"
      outline
      square
      small
      class="absolute! top-2 right-2 border-0!"
      @click="hide"
    >
      <BaseIcon name="close" class="text-xl" />
    </BaseButton>
    <!-- Show count -->
    <div
      v-if="count > 1"
      class="bg-gray absolute -top-1 -left-1 flex size-6 items-center justify-center rounded-full text-sm text-white"
    >
      {{ count }}
    </div>
  </div>
</template>

<script setup>
import useNotificationStore from "@/stores/notificationStore.js"
import { BaseButton, BaseIcon } from "@repowerednl/ui-component-library"

const notificationStore = useNotificationStore()

const props = defineProps({
  uid: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    default: null,
  },
  action: {
    type: Function,
    default: null,
  },
  actionLabel: {
    type: String,
    default: null,
  },
  count: {
    type: Number,
    default: 1,
  },
})

function hide() {
  notificationStore.remove(props.uid)
}
</script>
